import { render, staticRenderFns } from "./FacturaImpresion.vue?vue&type=template&id=71984d52&"
import script from "./FacturaImpresion.vue?vue&type=script&lang=js&"
export * from "./FacturaImpresion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports